import VideoBackground from "./VideoBackground";
import { Image } from "capitalrx-components-2.0/lib/general";

import FindBestPriceSearch from "../FindBestPriceSearch";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import styles from "./HomeHero.module.scss";
import { getCardBrandText, getHomeHeroImage } from "@/utils/branding";

const HomeHero = (): JSX.Element => {

  const cardBrandText = getCardBrandText();
  const heroImage = getHomeHeroImage();

  return (
    <div className={styles.HomeHeroWrapper}>
      <VideoBackground />

      <div className={styles.HomeHeroContainer}>
        <div className={styles.HomeHeroHeader}>
          <Heading level={1} textAlign="center" testId="advantage-main-heading">
            Save up to 90% on your prescriptions
          </Heading>
          <span data-testid="advantage-heading-subtext">with the FREE {cardBrandText}*</span>
          <p className={styles.HomeHeroCaveat}>*Based on the difference between the U&C submitted by the pharmacy and the price the patients pay</p>
        </div>
        <div className={styles.HomeHeroFindBestPriceSearchWrapper}>
          <FindBestPriceSearch />
        </div>
        <div className={styles.HomeHeroCardImage}>
          <Image
            className={styles.HomeHeroCardImageAsset}
            src={heroImage}
            alt={cardBrandText}
            aria-hidden="true"
            data-testid="advantage-card-image"
          />
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
